import React, { useMemo } from 'react';
import {
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from 'reactstrap';

import CommentBox from '../../../../comment/box';

const VersionerDocumentComparisonSidebarChatContainer = props => {
  const {
    item,
    configuration,
    helpers: {
      isPortalContext: isPortalContextHelper,
      itemName: itemNameHelper
    }
  } = props;

  const portalRoutes = () => {
    return {
      defaultRequestParams: {
        tenant: configuration?.tenant,
        resource_id: item?.hashid
      },
      routes: {
        createCommentPath: Routes.portal_comment_versioner_document_items_path,
        indexCommentPath: Routes.portal_comment_versioner_document_items_path,
        downloadFileCommentPath: Routes.download_attach_portal_comment_versioner_document_item_path
      }
    }
  }

  const routesConfiguration = () => {
    if (isPortalContextHelper) {
      return portalRoutes();
    }

    return {
      defaultRequestParams: {
        resource_id: item?.hashid
      },
      routes: {
        createCommentPath: Routes.comment_versioner_document_items_path,
        indexCommentPath: Routes.comment_versioner_document_items_path,
        downloadFileCommentPath: Routes.download_attach_comment_versioner_document_item_path
      }
    }
  }

  const currentOptions = useMemo(() => {
    return routesConfiguration();
  }, [item]);

  const {
    defaultRequestParams,
    routes
  } = currentOptions;

  return (
    <AccordionItem>
      <AccordionHeader targetId="2">
        <h2 className="fs-6 fw-bold mb-0">
          <i className="far fa-comments mr-2"></i>
          Comentarios
          <small className="fw-bold d-block">
            {itemNameHelper(item)}
          </small>
        </h2>
      </AccordionHeader>

      <AccordionBody accordionId="2">
        <CommentBox
          key={`CommentBox-${item.id}`}
          configuration={{
            defaultRequestParams,
            routes
          }}
          data={{
            currentUser: props?.data?.currentUser
          }}
        />
      </AccordionBody>
    </AccordionItem>
  );
};

export default VersionerDocumentComparisonSidebarChatContainer;
